import { Loader2 } from 'lucide-react';
import { TableRow, TableCell } from '../ui/Table';

// ----------------------------------------------------------------------

interface TableLoadingProps {
  isNotFound?: boolean;
}

export default function TableLoading({ isNotFound }: TableLoadingProps) {
  if (isNotFound) {
    return null;
  }

  return (
    <TableRow>
      <TableCell colSpan={12}>
        <div className="flex flex-col items-center justify-center py-12">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
          <p className="mt-2 text-sm text-muted-foreground">Loading...</p>
        </div>
      </TableCell>
    </TableRow>
  );
}
